var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tiptap-wrapper",class:{'err': _vm.editorValid}},[(_vm.editor)?_c('TipTapExtensionsMenu',{attrs:{"editor":_vm.editor}}):_vm._e(),_c('EditorContent',{attrs:{"editor":_vm.editor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }